import React from 'react';
import { Icon } from '../Icon/Icon';
import type { TriageStaff } from '../../triage/types';

export interface TriageAssigneeAvatarProps {
  staff: TriageStaff | null;
  size?: number;
  showRing?: boolean;
}

export function TriageAssigneeAvatar({ staff, size = 28, showRing }: TriageAssigneeAvatarProps) {
  if (!staff) {
    return (
      <div
        className="ti-avatar ti-avatar-empty"
        style={{ width: size, height: size, fontSize: size * 0.42 }}
      >
        <Icon kind="plus" size={Math.round(size * 0.45)} stroke={2} color="var(--ink-3)" />
      </div>
    );
  }

  return (
    <div
      className="ti-avatar"
      title={`${staff.name} · ${staff.role}`}
      style={{
        width: size,
        height: size,
        background: staff.color,
        fontSize: size * 0.36,
        boxShadow: showRing
          ? `0 0 0 2px var(--cream-1), 0 0 0 3.5px ${staff.color}`
          : undefined,
      }}
    >
      {staff.initials}
    </div>
  );
}
